import * as React from "react"
import { Col, Container, Row } from "react-grid-system"
import { useParams } from "react-router"
import H1 from "../atoms/typography/H1"
import { useUser } from "../../hooks/useUser"
import { profileNavigationItems } from "../../utils/paths"
import SubpagesNavigationBar from "../molecules/SubpagesNavigationBar"
import { HorizontalSpacer, Spacer } from "../atoms/spacers"
import LandingPage from "./organization/LandingPage"
import AccountPage from "./profile/AccountPage"
import NotificationsPage from "./profile/NotificationsPage"
import ReceiptsPage from "../templates/ReceiptsPage"
import { useUserReceipts } from "../../hooks/useUserReceipts"

const ProfilePage: React.FunctionComponent = () => {
  const { slug } = useParams()
  const { user } = useUser()

  React.useEffect(() => {
    document.title = "Profile"
  }, [])

  const showLandingPage = false

  return (
    <div>
      <Container>
        <HorizontalSpacer spacing={3.5} />
        <Row>
          <Spacer spacing={1} />
          <Col>
            <H1>
              {user?.firstName} {user?.lastName}
            </H1>
          </Col>
        </Row>
        <HorizontalSpacer spacing={3.5} />
        {showLandingPage ? (
          <LandingPage />
        ) : (
          <>
            <SubpagesNavigationBar items={profileNavigationItems} selectedItem={slug ?? "account"} />
            <HorizontalSpacer spacing={2} />
            {!slug && <AccountPage />}
            {slug === "account" && <AccountPage />}
            {slug === "receipts" && <ReceiptsPage queryHook={useUserReceipts} />}
            {slug === "notifications" && <NotificationsPage />}
          </>
        )}
      </Container>
      <HorizontalSpacer spacing={2} />
    </div>
  )
}

export default ProfilePage
